(function() {
  var $b5fcc396bfc311ff$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("filter-trigger")) return;
    class FilterTrigger extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button") || this.querySelector("summary");
      }
      connectedCallback() {
        if (this.button) this.button.addEventListener("click", this.#onButtonClick);
      }
      disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.#onButtonClick);
      }
      #onButtonClick=event => {
        event.preventDefault();
        const drawer = document.getElementById("filter-drawer");
        if (drawer) {
          const disclosure = drawer.closest("details-disclosure");
          if (disclosure && typeof disclosure.open === "function") disclosure.open(); else drawer.setAttribute("open", "");
        }
      };
    }
    customElements.define("filter-trigger", FilterTrigger);
  })();
})();